import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu } from 'lucide-react';
import MobileSidebar from './MobileSidebar';

function Header() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const openSidebar = () => setIsSidebarOpen(true);
  const closeSidebar = () => setIsSidebarOpen(false);

  return (
    <header className="w-full bg-white/95 backdrop-blur border-b border-gray-200 sticky top-0 z-50">
      <div className="flex justify-between items-center px-6 lg:px-12 py-4 max-w-7xl mx-auto w-full">
        
        {/* Logo */}
        <div className="flex items-center">
          <Link to="/" className="flex items-center">
            <img src="/logo.png" alt="Interconnect Systems Logo" className="h-14 md:h-16 w-auto object-contain" />
          </Link>
        </div>

        {/* Desktop Navigation (Hidden on Mobile/Tablet, visible on LG screens up) */}
        <nav className="hidden lg:flex space-x-8 text-sm font-medium text-gray-700">
          <Link to="/" className="hover:text-blue-900 transition-colors">Home</Link>
          <Link to="/about" className="hover:text-blue-900 transition-colors">About Us</Link>
          <Link to="/services" className="hover:text-blue-900 transition-colors">Services</Link>
          <Link to="/products" className="hover:text-blue-900 transition-colors">Products &amp; Design</Link>
          <Link to="/contact" className="hover:text-blue-900 transition-colors">Contact</Link>
        </nav>

        {/* Desktop Right Side CTA */}
        <div className="hidden lg:flex items-center gap-6">
          <Link
            to="/contact"
            className="bg-cogCyan hover:bg-cyan-300 text-cogLight font-semibold px-6 py-2.5 rounded-full transition-all duration-300 text-sm block"
          >
            Get a Quote
          </Link>
        </div>

        {/* Mobile Menu Button (Visible on Mobile/Tablet, hidden on LG screens) */}
        <div className="flex lg:hidden items-center">
          <button onClick={openSidebar} className="focus:outline-none text-cogBrand p-1" aria-label="Open menu">
            <Menu className="w-7 h-7" />
          </button>
        </div>
      </div>

      {/* Mobile Drawer */}
      <MobileSidebar isOpen={isSidebarOpen} onClose={closeSidebar} />
    </header>
  );
}

export default Header;